// mall 微服务接口
import request from '@/utils/request'
import base from '@/api/base'
const microApi = {
  changeHeadshot: base.api + '/family/auth/setting/changeHeadshot', // 头像上传
}

/**
 * 头像上传
 * @returns
 */
export const setUserInfo = (data) => {
  return request({
    url: microApi.changeHeadshot,
    method: 'post',
    data,
  })
}
